import * as React from 'react';
import { ScreenName } from 'lib/types';

/** Demo screen navigation functions */
export interface NavFunctions {
	goToAScreen: (nav: ScreenName) => void;
	goToNextScreen: () => void;
}

const defaultNav: NavFunctions = {
	goToAScreen: () => { return; },
	goToNextScreen: () => { return; }
};

/** React Context that provides demo screen navigation functions */
const NavContext = React.createContext(defaultNav);

export default NavContext;


// WEBPACK FOOTER //
// ./src/lib/NavContext.tsx